/**
 * @generated SignedSource<<29529a4d2e25fc89701bba25e706395c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueTable451BadPattern$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GroupTableBody938BadPattern" | "TableBody972BadPattern">;
  readonly " $fragmentType": "IssueTable451BadPattern";
};
export type IssueTable451BadPattern$key = {
  readonly " $data"?: IssueTable451BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTable451BadPattern">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "isConditionalFormattingEnabled",
    "variableName": "isConditionalFormattingEnabled"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "IssueTable451BadPattern",
  "selections": [
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "GroupTableBody938BadPattern"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "TableBody972BadPattern"
    }
  ],
  "type": "JiraProject"
};
})();

(node as any).hash = "f5f851914ac97371a66bf07d0fcb1c13";

export default node;
